import React from "react";
import { useQuery } from "@tanstack/react-query";
import { ApolloClient, NormalizedCacheObject } from "@apollo/client";

import ClipCard from "./ClipCard";
import { PodcastSelectionInterface } from "./PodcastSelectionInterface";
import "./clipsView.css";
import { fetchClipsData } from "./fetchClipsData";
import { ClientClipProjection } from "./ViewModels/ClientClipProjection";
import { DurationKind } from "./DurationKind";

function refreshButton(performRefresh: () => void): JSX.Element {
  return (
    <button
      onClick={() => {
        performRefresh();
      }}
      type="button"
      className="refresh-button"
    >
      Shuffle 🔀
    </button>
  );
}

export function clipsView(
  podrankApolloGqlClient: ApolloClient<NormalizedCacheObject>,
  selectedPodcasts: PodcastSelectionInterface[],
  selectedDurationKind: DurationKind,
  refreshState: number,
  setSelectedClip: (clip: ClientClipProjection) => void,
  performRefresh: () => void
): JSX.Element {
  // rerun the query when the selectedPodcasts change:
  const { isLoading, isError, data } = useQuery(
    ["clips", selectedPodcasts, selectedDurationKind, refreshState],
    () =>
      fetchClipsData(
        selectedPodcasts,
        selectedDurationKind,
        podrankApolloGqlClient
      )
  );

  if (isLoading) {
    return <span>Loading...</span>;
  }

  if (isError) {
    return <span>Error</span>;
  }

  return (
    <div>
      {refreshButton(performRefresh)}

      <section className="card-container">
        {data.map((clip) => (
          <div key={clip.id}>{ClipCard(clip, setSelectedClip)}</div>
        ))}
      </section>
    </div>
  );
}
